import * as React from "react";
import { HelpCircle } from "lucide-react";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/components/ui/hover-card";

interface HelpTooltipProps {
  title: string;
  content: string;
  children?: React.ReactNode;
  side?: "top" | "right" | "bottom" | "left";
}

export const HelpTooltip = ({ 
  title, 
  content, 
  children, 
  side = "right" 
}: HelpTooltipProps) => {
  return (
    <HoverCard openDelay={200}>
      <HoverCardTrigger asChild>
        <button 
          type="button"
          className="inline-flex items-center justify-center rounded-full hover:bg-muted transition-colors p-1"
          aria-label={`Help: ${title}`}
        >
          <HelpCircle className="h-4 w-4 text-muted-foreground hover:text-foreground transition-colors" />
        </button>
      </HoverCardTrigger>
      <HoverCardContent side={side} className="w-80">
        <div className="space-y-2">
          <h4 className="font-semibold text-sm">{title}</h4>
          <p className="text-sm text-muted-foreground">{content}</p>
          {children}
        </div>
      </HoverCardContent>
    </HoverCard>
  );
};
